import { _billingUrls } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

const deleteInvestigationApi = createAsyncThunk('deleteInvestigationApi', async (data: any) => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
  const { id } = data;

  try {
    const url = `${_billingUrls.deleteInvestigation}?hospital=${hospitalId}`;

    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        hospitalId: hospitalId,
        uniqueCode: id,
      }),
    });

    return await response.json();
  } catch (error) {
    return error;
  }
});

export default deleteInvestigationApi;
